<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><customer-sidebar></customer-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Mes Équipes</h2>
                        </div>

                        <div>
                            <div class="d-flex justify-content-center align-items-center">
                                <a v-for="tab in tabs" @click="activeTab=tab.id;data=tab.data;currentPage=1" :class="{ 'bg-warning-light': activeTab === tab.id }" 
                                    href="javascript:void(0)" class="badge badge-pill text-dark bg-light text-xs mr-1 py-3 px-4">{{ tab.label }}</a>
                            </div>

                            <div class="tab-content py-3 mb-5">
                                <div class="tab-pane fade show active pt-3">
                                    <div v-if="activeTab === 'teams'">
                                        <div class="text-center">
                                            <a href="/my/teams/new" class="btn btn-sm bg-light text-xs mb-2 d-inline-flex h-auto align-items-center rounded-pill px-3 mr-2">
                                                <span class="material-symbols-outlined text-md mr-2">group_add</span>
                                                Créer une équipe
                                            </a>
                                            <a href="javascript:void(0)" data-toggle="modal" data-target="#searchTeamModal" @click="searchTeam()" class="btn btn-sm bg-light text-xs mb-2 d-inline-flex h-auto align-items-center rounded-pill px-3">
                                                <span class="material-symbols-outlined text-md mr-2">search</span>
                                                Rechercher une équipe
                                            </a>
                                        </div>
                                        <div v-if="teams.length === 0" class="text-center">
                                            <span class="text-sm d-block mb-4 mt-2">Aucune équipe.</span>
                                        </div>
                                    </div>
                                    <div v-if="activeTab === 'requests'">
                                        <div v-if="requests.length === 0" class="text-center mt-2">
                                            <span class="text-xs">Aucune demande.</span>
                                        </div>
                                    </div>
                                    <div v-if="activeTab === 'invitations'">
                                        <div v-if="invitations.length === 0" class="text-center mt-2">
                                            <span class="text-xs">Aucune invitation.</span>
                                        </div>
                                    </div>
                                    <div v-if="data.length !== 0">
                                        <div class="table-responsive text-xs p-lg-2 p-0 mt-2">
                                            <table class="table table-hover table-center mb-0">
                                                <thead class="bg-light">
                                                    <tr>
                                                        <th v-if="activeTab !== 'teams'">Nom Joueur</th>
                                                        <th>Nom Équipe</th>
                                                        <th v-if="activeTab === 'teams'">Format</th>
                                                        <th v-if="activeTab === 'teams'">Role</th>
                                                        <th v-if="activeTab !== 'teams'">Type / Statut</th>
                                                        <th>Actions</th>
                                                        <th v-if="activeTab !== 'teams'">Reçue le</th>
                                                        <th v-if="activeTab !== 'teams'">Envoyée le</th>
                                                        <th v-if="activeTab === 'teams'">Rejoint le</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item in paginatedData" :key="item.id">
                                                        <td  v-if="activeTab !== 'teams'" :class="{ 'font-weight-bold': item?.player?.id === player.id }">
                                                            <span class="mr-1">{{ item?.player?.name || '-' }}</span>
                                                            <span v-if="item?.player?.id === player.id" 
                                                                class="badge badge-pill bg-secondary-light text-xs py-1 px-2">Moi</span>
                                                        </td>
                                                        <td style="min-width: 160px;" class="position-relative">
                                                            <div class="d-flex flex-row align-items-center">
                                                                <img :src="((activeTab !== 'teams') ? item.team.logo : item.logo) || defaultLogoPath" class="mr-2 bg-white rounded-lg" style="width: 35px;height: 35px;" />
                                                                <div class="text-xs">
                                                                    <a class="stretched-link" v-if="[item.team?.captain_id, item.team?.owner_id, item.captain_id, item.owner_id].includes(player.id)" :href="(activeTab !== 'teams') ? '/my/teams/' + item.team?.id + '/edit' : '/my/teams/' + item.id + '/edit'">
                                                                        <b>{{ (activeTab !== 'teams') ? item.team.name : item.name }}</b>
                                                                    </a>
                                                                    <a class="stretched-link" v-else :href="(activeTab !== 'teams') ? '/my/teams/' + item.team?.id : '/my/teams/' + item.id">
                                                                        {{ (activeTab !== 'teams') ? item.team.name : item.name }}
                                                                    </a>
                                                                    <span class="text-muted d-block text-xs">{{ (activeTab !== 'teams') ? item.team.delegation : item.delegation }}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td v-if="activeTab === 'teams'">{{ item.format }}</td>
                                                        <td v-if="activeTab === 'teams'">
                                                            {{ membershipRoles[item.membership.role] }}
                                                            <!-- <b v-if="item.captain_id == player.id" class="ml-1">(C)</b> -->
                                                        </td>
                                                        <td v-if="activeTab !== 'teams'">
                                                            <span class="badge badge-pill bg-info-light text-xs py-1 px-2 mr-2 mb-1" v-if="activeTab === 'requests'">
                                                                {{ (item.player_id === player.id) ? 'envoyée' : 'reçue' }}
                                                            </span>
                                                            <span class="badge badge-pill bg-info-light text-xs py-1 px-2 mr-2 mb-1" v-if="activeTab === 'invitations'">
                                                                {{ (item.player_id !== player.id) ? 'envoyée' : 'reçue' }}
                                                            </span>
                                                            <span :class="getMembershipStatusMeta(item.status).class" class="badge badge-pill text-xs py-1 px-2">
                                                                {{ getMembershipStatusMeta(item.status).label }}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-if="activeTab === 'teams' && (player.id !== item.owner_id || player.id !== item.captain_id)" class="btn btn-sm btn-danger py-0 px-1 mb-1" 
                                                                title="Annuler" @click="updateRequest(item.id, player.id, 'cancelled', item.origin)">
                                                                <span class="material-symbols-outlined text-sm">close</span>
                                                            </span>
                                                            
                                                            <span v-if="activeTab !== 'teams' && ( item.player_id !== player.id && item.status === 'pending' && item.origin === 'request' || item.player_id === player.id && item.status === 'pending' && item.origin === 'invitation')" class="btn btn-sm btn-danger py-0 px-1 mr-2 my-1" 
                                                                title="Refuser" @click="updateRequest(item.team.id, item.player.id, 'declined', item.origin)">
                                                                <span class="material-symbols-outlined text-sm">close</span>
                                                            </span>
                                                            <span v-if="activeTab !== 'teams' && ( item.player_id !== player.id && item.status === 'pending' && item.origin === 'request' || item.player_id === player.id && item.status === 'pending' && item.origin === 'invitation')" class="btn btn-sm btn-success py-0 px-1" 
                                                                title="Accepter" @click="updateRequest(item.team.id, item.player.id, 'accepted', item.origin)">
                                                                <span class="material-symbols-outlined text-sm">check</span>
                                                            </span>
                                                            <!-- <span v-if="activeTab === 'invitations' && ( item.player_id !== player.id && item.status === 'pending' && item.origin === 'invitation')" class="btn btn-sm btn-danger py-0 px-1" 
                                                                title="Annuler" @click="updateRequest(item.team.id, item.player.id, 'cancelled', item.origin)">
                                                                <span class="material-symbols-outlined text-sm">close</span>
                                                            </span> -->
                                                            <a v-if="activeTab === 'teams' && item.owner_id === player.id" @click="challenge(item)"
                                                                class="btn btn-sm btn-info text-xs"  data-toggle="modal" data-target="#searchTeamModal">
                                                                Défier
                                                            </a>
                                                            <!-- <span v-if="activeTab === 'sent' && item.status === 'accepted' && item.origin === 'request'" class="btn btn-sm btn-danger py-0 px-1" 
                                                                title="Annuler" @click="updateRequest(request.team.id, request.player.id, 'cancelled')">
                                                                <span class="material-symbols-outlined text-sm">close</span>
                                                            </span> -->
                                                        </td>
                                                        <td v-if="activeTab !== 'teams'">
                                                            {{ formatDateTime(item.requested_at).date }}
                                                            <span class="d-block text-muted text-xs">
                                                                à {{ formatDateTime(item.requested_at).time }}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {{ formatDateTime((activeTab !== 'teams') ? item.joined_at : item.membership.joined_at).date }}
                                                            <span class="d-block text-muted text-xs" v-if="item.joined_at || item?.membership?.joined_at">
                                                                à {{ formatDateTime((activeTab !== 'teams') ? item.joined_at : item.membership.joined_at).time }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- PAGINATION -->
                                        <nav class="mt-3">
                                            <ul class="pagination justify-content-center">
                                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                    <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                                                        <span class="material-symbols-outlined text-sm">arrow_back</span>
                                                    </button>
                                                </li>
                                                <li class="page-item">
                                                    <select class="page-link text-dark text-xs h-100" v-model="currentPage" @change="goToPage(Number(currentPage))">
                                                        <option v-for="page in totalPages" :key="page" :value="page">
                                                            Page {{ page }}
                                                        </option>
                                                    </select>
                                                </li>
                                                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                                    <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                                                        <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>

    <div class="modal fade" id="searchTeamModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header align-items-center">
                    <h5 v-if="currentModalView == 'search'" class="modal-title">Rechercher une équipe</h5>
                    <h5 v-if="currentModalView == 'details'" class="modal-title">Équipe - {{ selectedTeam.name }} </h5>
                    <h5 v-if="currentModalView == 'filters'" class="modal-title">Filtres de recherche</h5>
                    <h5 v-if="currentModalView == 'challenge'" class="modal-title">Composer le défi</h5>
                    <button v-if="currentModalView == 'search'" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                    <button v-if="currentModalView !== 'search'" @click="currentModalView = 'search'" type="button" class="btn btn-sm btn-outline-secondary">Retour</button>
                </div>
                <div class="modal-body mb-4" style="min-height: 30vh;">
                    <div id="searchData" v-if="currentModalView == 'search'">
                        <form class="form-inline">
                            <input type="text" v-model="search.criteria.teams.name" class="form-control shadow-sm rounded-pill bg-light mr-2 w-auto" placeholder="Nom Équipe" style="min-height: 40px;">
                            <a href="javascript:void(0)" class="btn bg-light rounded-pill d-flex align-items-center shadow-sm text-sm ml-1 py-2 px-3" 
                                @click="currentModalView = 'filters'" :class="{ 'border-dark': activeFiltersCount > 0}">
                                <span class="material-symbols-outlined text-sm mr-1">tune</span>
                                Filtres
                            </a>
                        </form>
                        <div v-if="filteredTeamData.length > 0">
                            <div class="table-responsive text-xs pt-2">
                                <table class="table table-hover table-center mb-0">
                                    <thead class="bg-light">
                                        <tr>
                                            <th>Nom Équipe</th>
                                            <th>Format</th>
                                            <th>Délégation</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="team in paginatedTeamData" :key="team.id">
                                            <td>
                                                <a href="javascript:void(0)" @click="selectedTeam = team; currentModalView = 'details'">
                                                    <b>{{ team.name }}</b>
                                                </a>
                                            </td>
                                            <td>{{ team.format }}</td>
                                            <td>{{ team.delegation }}</td>
                                            <td>
                                                <span v-if="!isEmpty(challengingTeam) && !activeMembershipOrPending(team)" @click="challengeRequest(team)"
                                                    class="btn btn-sm btn-outline-primary rounded-pill pt-0">
                                                    <span class="text-xs">Défier</span>
                                                </span>
                                                <span v-else-if="!activeMembershipOrPending(team)" @click="joinRequest(team.id)"
                                                    class="btn btn-sm btn-outline-info rounded-pill pt-0">
                                                    <span class="text-xs">Rejoindre</span>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- PAGINATION -->
                            <nav class="mt-3">
                                <ul class="pagination justify-content-center">
                                    <li class="page-item" :class="{ disabled: currentTeamPage === 1 }">
                                        <button class="page-link text-dark" @click="goToPage(currentTeamPage - 1, 'teams')">
                                            <span class="material-symbols-outlined text-sm">arrow_back</span>
                                        </button>
                                    </li>
                                    <li class="page-item">
                                        <select class="page-link text-dark text-xs h-100" v-model="currentTeamPage" @change="goToPage(Number(currentTeamPage), 'teams')">
                                            <option v-for="page in totalTeamPages" :key="page" :value="page">
                                                Page {{ page }}
                                            </option>
                                        </select>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentTeamPage === totalTeamPages }">
                                        <button class="page-link text-dark" @click="goToPage(currentTeamPage + 1, 'teams')">
                                            <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div v-else class="mt-5 text-xs text-center">
                            Aucune correspondance précise
                        </div>
                    </div>
                    <div id="teamDetails" v-if="currentModalView == 'details'">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="d-flex flex-row align-items-top mt-1 mb-3">
                                    <img :src="selectedTeam.logo || defaultLogoPath" class="mr-1" style="width: 70px;height: 70px;" />
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Nom de l'Équipe</label>
                                        <span class="input form-control">{{ selectedTeam.name }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group card-label h-100 mb-3">
                                    <label>Délégation</label>
                                    <span class="input form-control">{{ selectedTeam.delegation }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group card-label h-100 mb-3">
                                    <label>Format</label>
                                    <span class="input form-control">{{ selectedTeam.format }}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group card-label h-100 mb-3">
                                    <label>Formation</label>
                                    <span class="input form-control">{{ selectedTeam.formation }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="challengeData" v-if="currentModalView == 'challenge'">
                        <div class="mb-3 d-flex justify-content-between align-items-start flex-wrap">
                            <div>
                                <h6 class="mb-1">Défi contre {{ selectedTeam.name }}</h6>
                                <p class="text-xs text-muted mb-0">Ajoutez jusqu'à 2 propositions: terrain, date et heure.</p>
                            </div>
                            <span class="badge badge-pill bg-light text-dark">{{ challengeSuggestions.length }}/2 propositions</span>
                        </div>

                        <div v-for="(suggestion, index) in challengeSuggestions" :key="suggestion.uid" class="border rounded-lg p-3 mb-2 bg-light">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <strong class="text-sm">Proposition {{ index + 1 }}</strong>
                                <button v-if="challengeSuggestions.length > 1" type="button" class="btn btn-sm btn-link text-danger p-0" @click="removeSuggestion(index)">Retirer</button>
                            </div>
                            <div class="form-row">
                                <div class="col-md-4 mb-2">
                                    <label class="text-xs mb-1">Terrain</label>
                                    <div v-if="suggestion.facility_id" class="mb-2 p-2 border rounded bg-white">
                                        <div v-if="suggestion.establishment_name" class="text-sm font-weight-bold">{{ suggestion.establishment_name }}</div>
                                        <div v-if="suggestion.facility_name" class="text-xs text-muted">Terrain: {{ suggestion.facility_name }}</div>
                                    </div>
                                    <div v-else class="mb-2 p-2 border rounded bg-light text-xs text-muted">Aucun terrain choisi</div>
                                    <button type="button" class="btn btn-sm btn-outline-secondary w-100" @click="openFacilityPicker(index)">
                                        Choisir
                                    </button>
                                </div>
                                <div class="col-md-4 mb-2">
                                    <label class="text-xs mb-1">Date</label>
                                    <input type="date" v-model="suggestion.date" class="form-control form-control-sm" @change="loadSuggestionSlots(index)">
                                </div>
                                <div class="col-md-4 mb-2">
                                    <label class="text-xs mb-1">Créneau</label>
                                    <select class="form-control form-control-sm custom-select" v-model.number="suggestion.slot_index" :disabled="!suggestion.facility_id || !suggestion.date || suggestion.loading_slots" @change="onSuggestionSlotChange(index)">
                                        <option :value="-1">Choisir...</option>
                                        <option v-for="(slot, slotIndex) in suggestion.slots" :key="slot.id" :value="slotIndex">
                                            {{ formatSlotLabel(slot) }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="suggestion.loading_slots" class="text-xs text-muted mt-1">
                                Chargement des créneaux...
                            </div>
                            <div v-else-if="suggestion.date && suggestion.facility_id && suggestion.slots.length === 0" class="text-xs text-muted mt-1">
                                Aucun créneau confirmé disponible pour cette date.
                            </div>
                        </div>

                        <button v-if="challengeSuggestions.length < 2" type="button" class="btn btn-sm btn-outline-secondary rounded-pill mt-2" @click="addSuggestion()">
                            Ajouter une proposition
                        </button>
                    </div>
                    <div id="teamFilters" v-if="currentModalView == 'filters'">
                        <div class="form-group card-label h-100 mb-3">
                            <label class="bg-light">Délégation</label>
                            <v-select :options="delegations" v-model="criteria.delegation" label="option" :reduce="option => option" class="custom-vs form-control input w-auto">
                                <template #option="{ option }">
                                    <span><b>{{ option.split(', ')[0]}}</b>, {{ option.split(', ')[1] }}</span>
                                </template>
                            </v-select>
                        </div>
                        <div class="form-group card-label h-100 mb-3 w-auto" style="min-width: 120px;">
                            <label>Format</label>
                            <select class="form-control custom-select" v-model="criteria.format" required="">
                                <template v-for="n in 11">
                                    <option v-if="n>=5" :value="n+'v'+n">{{ n }}v{{ n }}</option>
                                </template>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" v-if="currentModalView == 'filters'">
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="resetFilters()">Réinitialiser</button>
                    <button type="button" class="btn btn-sm btn-primary" @click="applyFilters()">Appliquer</button>
                </div>
                <div class="modal-footer" v-if="currentModalView == 'challenge'">
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="currentModalView = 'search'">Retour</button>
                    <button type="button" class="btn btn-sm btn-primary challenge-btn" @click="submitChallengeRequest()">
                        <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                        Envoyer le défi
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="facilityPickerModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header align-items-center">
                    <h5 class="modal-title">Choisir établissement et terrain</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeFacilityPicker()">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <div class="col-md-6 mb-2">
                            <label class="text-xs mb-1">Établissement</label>
                            <select class="form-control custom-select" v-model="facilityPicker.establishment_id" @change="onFacilityPickerEstablishmentChange()">
                                <option :value="null">Choisir...</option>
                                <option v-for="establishment in challengeEstablishments" :key="establishment.id" :value="establishment.id">
                                    {{ establishment.business_name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="text-xs mb-1">Terrain</label>
                            <select class="form-control custom-select" v-model="facilityPicker.facility_id">
                                <option :value="null">Choisir...</option>
                                <option v-for="facility in facilityPicker.facilities" :key="facility.id" :value="facility.id">
                                    {{ facility.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal" @click="closeFacilityPicker()">Annuler</button>
                    <button type="button" class="btn btn-sm btn-primary" @click="applyFacilityPicker()">Valider</button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import defaultLogoPath from '@/assets/img/default-team-logo.png'
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        vSelect
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        totalPages() {
            return Math.ceil(this.data.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.data.slice(start, start + this.perPage);
        },
        activeFiltersCount() {
            const keys = Object.keys(this.search.criteria.teams)
            let activeFilters = 0
            keys.forEach(key => {
                if (!this.isEmpty(this.criteria[key])) {
                    activeFilters++
                }
            })
            return activeFilters
        },
        filteredTeamData() {
            let filteredData = this.search.teams
            const keys = Object.keys(this.search.criteria.teams)
            keys.forEach(key => {
                if (!this.isEmpty(this.search.criteria.teams[key])) {
                    filteredData = filteredData.filter(team => {
                        return team[key].toLowerCase().includes(this.search.criteria.teams[key].toLowerCase())
                    });
                }
            })

            return filteredData
        },
        totalTeamPages() {
            return Math.ceil(this.filteredTeamData.length / this.teamsPerPage);
        },
        paginatedTeamData() {
            const start = (this.currentTeamPage - 1) * this.teamsPerPage;
            return this.filteredTeamData.slice(start, start + this.teamsPerPage);
        },
    },
    data() {
        return {
            defaultLogoPath: defaultLogoPath,
            activeTab: 'teams',
            tabs: {
                'teams' : { id: 'teams', label: 'Équipes', data: [] },
                'requests' : { id: 'requests', label: 'Demandes', data: [] },
                'invitations' : { id: 'invitations', label: 'Invitations', data: [] },
            },
            membershipStatuses: {
                'pending': {'label': 'en attente', 'class': 'bg-warning-light'},
                'accepted': {'label': 'accepté', 'class': 'bg-success-light'},
                'declined': {'label': 'rejeté', 'class': 'bg-danger-light'},
                'cancelled': {'label': 'annulé', 'class': 'bg-danger text-white'},
                'banned': {'label': 'bani', 'class': 'bg-danger text-white'},
                'abandoned': {'label': 'abandonné', 'class': 'bg-danger text-white'}
            },
            membershipRoles: {
                'captain': 'Capitaine',
                'starting': 'Titulaire',
                'substitute': 'Remplaçant'
            },
            membershipOrigins: {
                'invitation': {'label': 'invitation', 'class': 'bg-info-light'},
                'request': {'label': 'demande', 'class': 'bg-primary-light'},
            },
            playerPositions: {
                'goalkeeper': {'abbr': 'G', 'class': 'bg-warning-light'},
                'defender': {'abbr': 'DF', 'class': 'bg-info-light'},
                'midfielder': {'abbr': 'ML', 'class': 'bg-success-light'},
                'forward': {'abbr': 'AT', 'class': 'bg-danger-light'}
            },
            player: {},
            data: [],
            teams: [],
            receivedRequests: [],
            sentRequests: [],
            requests: [],
            invitations: [],
            search: {
                criteria: {
                    teams: {
                        name: null,
                        delegation: null,
                        format: null
                    }
                },
                teams: []
            },
            currentPage: 1,     // selected page
            perPage: 5,         // items per page
            currentTeamPage: 1,     // selected page
            teamsPerPage: 5,         // items per page
            currentModalView: 'search',
            criteria: {
                delegation: null,
                format: null
            },
            selectedTeam: {},
            challengeSuggestions: [],
            challengeEstablishments: [],
            challengeFacilitiesCatalog: [],
            quarterHourOptions: [],
            facilityPicker: {
                suggestionIndex: null,
                establishment_id: null,
                facility_id: null,
                facilities: [],
            },
            challengingTeam: {},
        }
    },
    mounted() {
        this.getMyPlayerProfile()
        this.getDelegations()
        this.getRequests()
        this.getInvitations()
        this.getCurrentTeams()
        // this.getInvitations()
        this.user = this.currentUser

        $('#facilityPickerModal').on('shown.bs.modal', () => {
            const modalZ = 20010
            const backdropZ = 20000
            $('#facilityPickerModal').css('z-index', modalZ)
            $('.modal-backdrop').last().css('z-index', backdropZ)
        })

        $('#facilityPickerModal').on('hidden.bs.modal', () => {
            $('#facilityPickerModal').css('z-index', '')
        })
    },
    methods: {
        getMyPlayerProfile() {
            api.get('/private/players/me')
                .then(response => {
                    const result = response.data
                    this.player = result
                })
        },
        getDelegations() {
            api.get('/core/static/regions/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        getPlayer(player_id) {
            api.get('/private/players/'+player_id)
                .then(response => {
                    const result = response.data
                    this.selectedPlayer = result
                })
        },
        getTeam(team_id) {
            api.get('/private/teams/'+team_id)
                .then(response => {
                    const result = response.data
                    this.selectedTeam = result
                })
        },
        getCurrentTeams() {
            api.get('/private/players/my/teams/current')
                .then(response => {
                    const result = response.data
                    this.teams = result.map(team => {
                        const myMembership = team.memberships.find(m => m.player_id === this.player.id)
                        return {
                            ...team,
                            membership: myMembership
                        }
                    })
                    this.tabs['teams'].data = this.teams
                    this.data = this.tabs[this.activeTab].data
                })
        },
        getRequests() {
            api.get('/private/players/my/requests')
                .then(response => {
                    const result = response.data
                    this.requests = result.filter(request => request.origin !== 'owner')
                    this.tabs['requests'].data = this.requests
                    this.data = this.tabs[this.activeTab].data
                })
        },
        getInvitations() {
            api.get('/private/players/my/invitations')
                .then(response => {
                    const result = response.data
                    this.invitations = result.filter(request => request.origin !== 'owner')
                    this.tabs['invitations'].data = this.invitations
                    this.data = this.tabs[this.activeTab].data
                })
        },
        joinRequest(team_id) {
            this.$store.dispatch('modal/triggerModal', {
                stacked: true,
                icon: 'warning',
                icon_color: 'text-warning',
                title: 'Attention!',
                detail: 'Voulez-vous rejoindre cette équipe?',
                prompt: true,
                onResult: (confirmed) => {
                    if (confirmed) {
                        api.post(`/private/teams/${team_id}/join-request`, {player_id: this.player.id})
                            .then(response => {
                                    this.$store.dispatch('modal/triggerModal', {
                                        stacked: true,
                                        icon: 'check_circle',
                                        icon_color: 'text-success',
                                        title: 'Succès',
                                        detail: 'Votre demande a été envoyée',
                                    })
                                    this.getRequests()
                                    this.searchTeams()
                                })
                            .catch(error => {
                                    this.$store.dispatch('modal/triggerModal', {
                                        stacked: true,
                                        icon: 'error',
                                        icon_color: 'text-danger',
                                        title: 'Erreur',
                                        detail: error.response?.data?.message || 'Une erreur est survenue! Veuillez réessayer plus tard.',
                                    })
                                })
                    }
                }
            })
        },
        updateRequest(team_id, player_id, status, origin='request') {
            let message = ''
            origin = (origin === 'request') ? 'demande' : 'invitation'
            switch(status) {
                case 'accepted':
                    message = `Voulez-vous accepter cette ${origin}?`
                    break
                case 'declined':
                    message = `Voulez-vous refuser cette ${origin}?`
                    break
                case 'cancelled':
                    message = 'Voulez-vous quitter cette équipe?'
                    break
                default:
                    message = 'Vous voulez continuer?'
            }
            this.$store.dispatch('modal/triggerModal', {
                icon: 'warning',
                icon_color: 'text-warning',
                title: 'Attention!',
                detail: message,
                prompt: true,
                onResult: (confirmed) => {
                    if (confirmed) {
                        api.patch(`/private/teams/${team_id}/requests/${player_id}`, {status: status})
                            .then(response => {
                                    this.$store.dispatch('modal/triggerModal', {
                                        icon: 'check_circle',
                                        icon_color: 'text-success',
                                        title: 'Succès',
                                        detail: 'L\'opération a été effectuée avec succès.',
                                    })
                                    this.getRequests()
                                    this.getInvitations()
                                    this.getCurrentTeams()
                                })
                            .catch(error => {
                                    this.$store.dispatch('modal/triggerModal', {
                                        icon: 'error',
                                        icon_color: 'text-danger',
                                        title: 'Erreur',
                                        detail: error.response?.data?.message || 'Une erreur est survenue! Veuillez réessayer plus tard.',
                                    })
                                })
                    }
                }
            })
        },
        newSuggestion() {
            const uniqueId = `${Date.now()}-${Math.random().toString(36).substring(2, 11)}-${Math.random().toString(36).substring(2, 11)}`
            return {
                uid: uniqueId,
                establishment_id: null,
                facility_id: null,
                facility_name: null,
                establishment_name: null,
                date: null,
                slot_index: -1,
                start_time: null,
                end_time: null,
                slots: [],
                loading_slots: false,
            }
        },
        getSuggestionFacilityLabel(suggestion) {
            if (!suggestion) return ''
            const establishmentName = suggestion.establishment_name || suggestion.establishment?.business_name || ''
            const facilityName = suggestion.facility_name || ''
            if (establishmentName && facilityName) {
                return `${establishmentName} - Terrain ${facilityName}`
            }
            if (facilityName) {
                return `Terrain ${facilityName}`
            }
            return establishmentName
        },
        formatSlotRange(slot) {
            if (!slot) return ''
            return `${this.formatTime(slot.start_time)} -> ${this.formatTime(slot.end_time)}`
        },
        formatSlotLabel(slot) {
            if (!slot) return ''
            return this.formatSlotRange(slot)
        },
        getMembershipStatusMeta(status) {
            return this.membershipStatuses[status] || {
                label: status || 'inconnu',
                class: 'bg-secondary-light',
            }
        },
        buildQuarterHourOptions() {
            const options = []
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 15) {
                    options.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`)
                }
            }
            return options
        },
        loadChallengeEstablishments() {
            return api.get('/search/facilities')
                .then(response => {
                    const facilities = response.data || []
                    this.challengeFacilitiesCatalog = facilities
                    const establishmentById = {}

                    facilities.forEach(facility => {
                        if (!facility?.establishment) return
                        const est = facility.establishment
                        if (!establishmentById[est.id]) {
                            establishmentById[est.id] = {
                                id: est.id,
                                business_name: est.business_name,
                            }
                        }
                    })

                    this.challengeEstablishments = Object.values(establishmentById)
                })
                .catch(() => {
                    this.challengeEstablishments = []
                    this.challengeFacilitiesCatalog = []
                })
        },
        loadFacilitiesByEstablishment(establishment_id) {
            if (!establishment_id) {
                this.facilityPicker.facilities = []
                return Promise.resolve([])
            }

            const facilities = this.challengeFacilitiesCatalog.filter(
                facility => facility.establishment_id === establishment_id
            )
            this.facilityPicker.facilities = facilities
            return Promise.resolve(facilities)
        },
        onFacilityPickerEstablishmentChange() {
            this.facilityPicker.facility_id = null
            this.loadFacilitiesByEstablishment(this.facilityPicker.establishment_id)
        },
        closeFacilityPicker() {
            if ($('#facilityPickerModal').hasClass('show')) {
                $('#facilityPickerModal').modal('hide')
            }
            const $backdrops = $('.modal-backdrop')
            if ($backdrops.length > 1) {
                $backdrops.last().remove()
            }
            this.facilityPicker.suggestionIndex = null
            this.facilityPicker.establishment_id = null
            this.facilityPicker.facility_id = null
            this.facilityPicker.facilities = []
        },
        openFacilityPicker(index) {
            const suggestion = this.challengeSuggestions[index]
            this.facilityPicker.suggestionIndex = index
            this.facilityPicker.establishment_id = suggestion?.establishment_id || this.selectedTeam?.preferred_establishment_id || null
            this.facilityPicker.facility_id = suggestion?.facility_id || null
            this.facilityPicker.facilities = []
            this.loadFacilitiesByEstablishment(this.facilityPicker.establishment_id).then(() => {
                this.$nextTick(() => {
                    $('#facilityPickerModal').modal('show')
                })
            })
        },
        applyFacilityPicker() {
            const index = this.facilityPicker.suggestionIndex
            if (index === null || index === undefined) return

            const selectedFacility = this.facilityPicker.facilities.find(facility => facility.id === this.facilityPicker.facility_id)
            this.challengeSuggestions[index].establishment_id = this.facilityPicker.establishment_id
            this.challengeSuggestions[index].facility_id = this.facilityPicker.facility_id
            this.challengeSuggestions[index].facility_name = selectedFacility?.name || null
            this.challengeSuggestions[index].establishment_name = selectedFacility?.establishment?.business_name || null
            this.challengeSuggestions[index].slot_index = -1
            this.challengeSuggestions[index].start_time = null
            this.challengeSuggestions[index].end_time = null
            this.closeFacilityPicker()
            this.loadSuggestionSlots(index)
        },
        loadSuggestionSlots(index) {
            const suggestion = this.challengeSuggestions[index]
            if (!suggestion) return Promise.resolve([])

            if (!suggestion.facility_id || !suggestion.date) {
                suggestion.slots = []
                suggestion.slot_index = -1
                suggestion.start_time = null
                suggestion.end_time = null
                return Promise.resolve([])
            }

            suggestion.loading_slots = true
            return api.get(`/search/slots/${suggestion.date}/facility/${suggestion.facility_id}`)
                .then(response => {
                    const result = response.data || []
                    const now = moment().format('YYYY-MM-DDTHH:mm:ss.000000')
                    const slots = result
                        .filter(slot => slot.available && slot.status === 'available' && slot.start_time > now)
                        .map(slot => ({
                            ...slot,
                            establishment_name: slot.facility?.establishment?.business_name || '',
                            facility_name: slot.facility?.name || '',
                        }))

                    suggestion.slots = slots
                    suggestion.slot_index = -1
                    suggestion.start_time = null
                    suggestion.end_time = null
                    return slots
                })
                .catch(() => {
                    suggestion.slots = []
                    suggestion.slot_index = -1
                    suggestion.start_time = null
                    suggestion.end_time = null
                    return []
                })
                .finally(() => {
                    suggestion.loading_slots = false
                })
        },
        onSuggestionSlotChange(index) {
            const suggestion = this.challengeSuggestions[index]
            if (!suggestion || suggestion.slot_index < 0) return
            const selectedSlot = suggestion.slots[suggestion.slot_index]
            
            suggestion.start_time = selectedSlot?.start_time || null
            suggestion.end_time = selectedSlot?.end_time || null
        
        },
        addSuggestion() {
            if (this.challengeSuggestions.length < 2) {
                const newSuggestion = this.newSuggestion()
                this.challengeSuggestions.push(newSuggestion)
            }
        },
        removeSuggestion(index) {
            if (this.challengeSuggestions.length > 1) {
                const uidToRemove = this.challengeSuggestions[index].uid
                this.challengeSuggestions = this.challengeSuggestions.filter(s => s.uid !== uidToRemove)
            }
        },
        challengeRequest(team) {
            this.selectedTeam = team
            this.challengeSuggestions = [this.newSuggestion()]
            this.closeFacilityPicker()
            this.loadChallengeEstablishments()
                .finally(() => {
                    this.currentModalView = 'challenge'
                })
        },
        submitChallengeRequest() {
            const hasPartialRow = this.challengeSuggestions.some(suggestion => {
                const hasAny = suggestion.facility_id || suggestion.date || suggestion.start_time || suggestion.end_time
                const hasAll = suggestion.facility_id && suggestion.date && suggestion.start_time && suggestion.end_time
                return hasAny && !hasAll
            })

            if (hasPartialRow) {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: 'Chaque proposition doit contenir terrain, date et heure.',
                })
                return
            }

            const suggestions = this.challengeSuggestions
                .filter(suggestion => suggestion.facility_id && suggestion.date && suggestion.start_time && suggestion.end_time)
                .map(suggestion => ({
                    facility_id: suggestion.facility_id,
                    date: suggestion.date,
                    start_time: suggestion.start_time,
                    end_time: suggestion.end_time,
                }))

            if (suggestions.length === 0) {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: 'Ajoutez au moins une proposition valide.',
                })
                return
            }
            console.log(suggestions)
            $('button.challenge-btn').attr('disabled', 'disabled')
            $('button.challenge-btn span').removeClass('d-none')
            this.$store.dispatch('modal/triggerModal', {
                icon: 'warning',
                icon_color: 'text-warning',
                title: 'Attention!',
                detail: 'Voulez-vous défier cette équipe?',
                prompt: true,
                onResult: (confirmed) => {
                    if (confirmed) {
                        api.post(`/private/teams/${this.challengingTeam.id}/challenge/${this.selectedTeam.id}`, { suggestions })
                            .then(response => {
                                    $('button.challenge-btn').removeAttr('disabled')
                                    $('button.challenge-btn span').addClass('d-none')
                                    if (!response || !response.data) {
                                        throw new Error('challenge_request_failed')
                                    }
                                    this.$store.dispatch('modal/triggerModal', {
                                        icon: 'check_circle',
                                        icon_color: 'text-success',
                                        title: 'Succès',
                                        detail: 'Votre défi a été envoyée',
                                    })
                                    this.currentModalView = 'search'
                                    this.challengeSuggestions = []
                                    this.challengeEstablishments = []
                                    this.challengeFacilitiesCatalog = []
                                    this.getRequests()
                                    this.searchTeams()
                                })
                            .catch(error => {
                                $('button.challenge-btn').removeAttr('disabled')
                                $('button.challenge-btn span').addClass('d-none')
                                console.error('Challenge request error:', error)
                                const detail = error.response?.data?.detail || error.response?.data?.message || error.message || 'Une erreur est survenue! Veuillez réessayer plus tard.'
                                const status = error.response?.status
                                this.$store.dispatch('modal/triggerModal', {
                                    icon: 'error',
                                    icon_color: 'text-danger',
                                    title: status ? `Erreur (${status})` : 'Erreur',
                                    detail: detail,
                                })
                            })
                    } else {
                        $('button.challenge-btn').removeAttr('disabled')
                        $('button.challenge-btn span').addClass('d-none')
                    }
                }
            })
        },
        searchTeams() {
            api.get('/private/teams/search')
                .then(response => {
                    const result = response.data
                    this.search.teams = result.filter(team => team.owner_id != this.player.id && team.captain_id != this.player.id)
                    this.currentTeamPage = 1
                })
        },
        searchTeam() {
            this.resetFilters()
            this.challengingTeam = {}
            this.searchTeams()
        },
        challenge(team) {
            this.resetFilters()
            this.challengingTeam = team
            this.searchTeams()
        },
        applyFilters() {
            this.search.criteria.teams = {
                ...this.search.criteria.teams,
                ...this.criteria
            }
            this.currentModalView = 'search'
        },
        resetFilters() {
            this.criteria = {
                delegation: null,
                format: null
            }
            this.applyFilters()
        },
        activeMembershipOrPending(team) {
            if (this.isEmpty(team)) return true
            const memberships = team.memberships.filter(m => m.player_id == this.player.id && ['accepted', 'pending'].includes(m.status))
            return memberships.length > 0
        },
        isEmpty(obj) {
            return obj === '' || obj == [] || obj === null || obj === undefined || 
                (typeof obj === 'object' && Object.keys(obj).length === 0);
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toISOString().split("T")[0];
            let displayDate = date.toLocaleDateString("fr-FR", { weekday: "short", year: "numeric", month: "short", day: "numeric" }).split("T")[0];
            displayDate = displayDate.split(" ") .map(word => word.charAt(0).toUpperCase() + word.slice(1)) .join(" ");
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: displayDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
        formatTime(datetimeString) {
            if (!datetimeString) return ''
            const date = new Date(datetimeString)
            const hours = date.getHours().toString().padStart(2, '0')
            const minutes = date.getMinutes().toString().padStart(2, '0')
            return `${hours}:${minutes}`
        },
        goToPage(page, list='default') {
            if (list == 'default' && page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
            if (list == 'teams' && page >= 1 && page <= this.totalTeamPages) {
                this.currentTeamPage = page;
            }
            if (list == 'players' && page >= 1 && page <= this.totalPlayerPages) {
                this.currentPlayerPage = page;
            }
        }
    },
    watch: {}
};
</script>
